import { action } from "typesafe-actions";
import { WhitelistActionTypes } from "./whitelist.model";

export const fetchWhitelistRequest = (req) => action(WhitelistActionTypes.FETCH_WHITELIST_REQUEST, req);
export const fetchWhitelistSuccess = (res) => action(WhitelistActionTypes.FETCH_WHITELIST_SUCCESS, res);
export const fetchWhitelistFailure = (err) => action(WhitelistActionTypes.FETCH_WHITELIST_FAILURE, err);
